<div class="flex align-items-center justify-content-center h-screen">
  <div class="surface-card p-4 shadow-2 border-round w-30rem">
    <form
      [formGroup]="loginForm"
      (ngSubmit)="onSubmit()"
      (keyup.enter)="onSubmit()"
    >
      <div class="field">
        <label for="email">{{ 'EMAIL' | translate }}</label>
        <input
          pInputText
          formControlName="email"
          id="email"
          type="text"
          pInputText
          class="w-full"
        />
        <small
          class="p-error"
          *ngIf="
          loginForm.controls['email'].errors?.['required'] &&
            loginForm.controls['email'].invalid &&
            loginForm.controls['email'].touched
          "
        >
          {{ 'EMAIL_REQUIRED' | translate }}
        </small>
        <small
          class="p-error"
          *ngIf="
          loginForm.controls['email'].errors?.['email'] &&
            loginForm.controls['email'].invalid &&
            loginForm.controls['email'].touched
          "
        >
          {{ 'EMAIL_INVALID' | translate }}
        </small>
        <div class="text-primary cursor-pointer mt-2" *ngIf="email && isNonSSO" (click)="onUseDifferentAccount()">
          {{ 'USE_A_DIFFERENT_ACCOUNT' | translate }}
        </div>
      </div>

      <div class="field" *ngIf="email && isNonSSO">
        <label for="password">{{ "PASSWORD" | translate}}</label>
        <input
          pInputText
          id="password"
          type="password"
          pInputText
          formControlName="password"
          class="w-full"
        />
        <small
          class="p-error"
          *ngIf="
            loginForm.controls['password'].invalid &&
            loginForm.controls['password'].touched
          "
        >
          {{ 'PASSWORD_IS_REQUIRED' | translate }}
        </small>
      </div>

      <div *ngIf="!email">
        <app-base-button
          [iconName]="isCheckingEmail ? 'pi pi-spin pi-spinner' : ''"
          label="CONTINUE"
          (onClick)="onSubmit()"
          [disabled]="isCheckingEmail"
        ></app-base-button>
      </div>
      <div *ngIf="email && isNonSSO">
        <app-base-button
          label="LOGIN"
          (onClick)="onLoginNonSSO()"
        ></app-base-button>
      </div>
    </form>
  </div>
</div>
``
